import React, { useState, useEffect } from 'react';
import ReportsClassic from './ReportsClassic';
import ReportsModern from './ReportsModern';

const Reports = () => {
  const [uiMode, setUiMode] = useState('classic');
  
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    setUiMode(user?.ui_mode || 'classic');
  }, []);

  // Render the appropriate component based on UI mode
  if (uiMode === 'modern') {
    return <ReportsModern />;
  }

  return <ReportsClassic />;
};

export default Reports;
